// packages & modules
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'
import * as actions from 'actions'
import * as home from 'modules/home'
import URL from 'modules/url'
// import LazyLoad from 'react-lazy-load'
import LazyLoad from 'react-lazyload'
import * as getInvolved from 'modules/getInvolved'

// generic
import Footer from 'components/Utils/Footer'
import LargeQuote from 'components/Utils/LargeQuote'
import RowThreeText from 'components/Utils/RowThreeText'
import Carousel from 'components/Utils/Carousel'
import RowThreeBlock from 'components/Utils/RowThreeBlock'
import Spinner from 'components/Utils/Spinner'
import AlertMini from 'components/Utils/AlertMini'

// specific to home:
import Circles from 'components/Home/Circles'
import GetInvolvedRows from 'components/Utils/GetInvolvedRows'


class Home extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props, isFetching: true }
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView()
    let { dispatch } = this.props,
        url = URL(this.props)
    dispatch(actions.token.fetchData(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let data, largeQuote, manifesto, links, team, getInvolvedLinks

    if (this.state.data) {
      data = this.state.data
      largeQuote = home.largeQuote(this.state.data)
      manifesto = home.manifesto()
      links = home.links()
      team = home.team()
      getInvolvedLinks = getInvolved.links(this.state.data)
    }

    let mobile = (window.innerWidth <= 480), green
    if (mobile) {
      green = (
        <div className="layer parallax__layer--deep">
          <img src={assets('images/camp-blob-4.png')} id="deep-1" style={{width: '100%', height: 'auto', minHeight: '100vh'}} />
        </div>
      )
    }

    if (this.state.isFetching) {
      return <main className="page"><Spinner/></main>
    } else {
      return (
        <main className="page fade-in">
          <AlertMini alertIsMinimized={true} />


          <div className="group0 parallax__group">

            <div className="layer parallax__layer--deep">
              <img src={assets('images/Home_Blob-2.png')} id="deep-1" style={{right: '0', position: 'absolute', height: 'auto', minHeight: '100vh'}} />
            </div>
            <div className="layer parallax__layer--back">
              <img src={assets('images/camp-blob-6.png')} id="deep-1" style={{width: '100%', height: 'auto', position: '', top: '0'}} />
            </div>

            <div className="layer parallax__layer--base">
              <LargeQuote data={largeQuote}/>
              <RowThreeText data={manifesto} />
              <Carousel start={0} end={19} />
              <div className="gakko-video orange">
                <iframe src="https://player.vimeo.com/video/195932509" height="100%" frameBorder="0" allowFullScreen></iframe>
              </div>
              <RowThreeBlock data={links} />
              <img className="center" src={assets('images/blobs/01.png')} style={{width: '100%', height: 'auto'}} />
              <RowThreeText data={team} />
              <Circles />
              <GetInvolvedRows data={getInvolvedLinks}/>

              <img src={assets('images/blobs/02.png')} style={{width: '100%', height: 'auto', marginTop: '20vh', marginBottom: '-1px'}} />
              <Footer />
            </div>
          </div>
        </main>
      )
    }
  }
}

// <LazyLoad offset={300} onContentVisible={() => console.log('lazy1')}>
// </LazyLoad>

Home.contextTypes = {
}
Home.propTypes = {
}

function mapStateToProps(state, ownProps) {
  return {
    previousLocation: state.location && state.location.locationBeforeTransitions.pathname,
    routes: ownProps,
    isFetching: state.token.isFetching,
    data: state.token.data
  }
}

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/components/Home.js